import axios from 'axios';

import rewriteUrls from './interceptors/rewriteUrls';
import redirectLegacyApis from './interceptors/redirectLegacyApis';
import refreshSessionIfExpired from './interceptors/refreshSessionIfExpired';
import addAuthorizationHeaderIfNotExists from './interceptors/addAuthorizationHeaderIfNotExists';
import migrateAuthTokenIfNeeded from './interceptors/migrateAuthTokenIfNeeded';

const axiosInstance = axios.create();

/**
 * NOTE: Axios executes the last registered interceptor first.
 */
axiosInstance.interceptors.request.use(addAuthorizationHeaderIfNotExists);
axiosInstance.interceptors.request.use(refreshSessionIfExpired);
axiosInstance.interceptors.request.use(migrateAuthTokenIfNeeded);
axiosInstance.interceptors.request.use(redirectLegacyApis);
axiosInstance.interceptors.request.use(rewriteUrls);

export default axiosInstance;
